import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { HttpUtilService } from '../config/http-util.service';

@Injectable()
export class ClinicalStaffService {

    private controller = 'team';

    constructor(private _http: Http, private _httpUtil: HttpUtilService) {
    }

    listAll(): Observable<any> {
        return this._http
        .get(this._httpUtil.url(this.controller + '/list/asc'))
        .map(res => res.json())
        .catch(err => Observable.throw(err.message));
    }
}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/clinical-staff/clinical-staff.service.ts